// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__37guw","legacyBtn":"MutateMid_legacyBtn__3Txes"};